import React, { useState, useMemo, useCallback, useContext } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Modal, Spin, Avatar } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import { deleteDriver, getDrivers } from "../services/driverApi";
import "../../Styles/style.css";
import AddEditDriverForm from "../component/AddEditDriver";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import vectorIcon from "../../../assets/images/Vector.png";
import vector1Icon from "../../../assets/images/Vector1.png";
import vectorStatut from "../../../assets/images/VectorStatut.png";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import IconDriver from "../../../assets/images/IconDriver.png";
import TableContainerMin from "../../../Components/Common/TableContainer";
import AddDriverMass from "../component/MassFile/AddMassDrivers";

const Drivers = (modal) => {
  const { t } = useTranslation();
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  document.title = `Chauffeurs | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isMassModalOpen, setIsMassModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteTargetFullName, setDeleteTargetFullName] = useState("");
  const {
    isLoading,
    isError,
    error,
    data: users = [],
  } = useQuery("users", getDrivers);
  const [isModalOpenExport, setIsModalOpenExport] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = useCallback((user = null) => {
    setSelectedUser(user);
    setIsModalOpen((prev) => !prev);
  }, []);
  const toggleModalExport = () => {
    setIsModalOpenExport((prev) => !prev);
  };

  const toggleAddEditModal = useCallback(
    (user = null) => {
      setSelectedUser(user);
      setIsAddEditModalOpen((prev) => !prev);
      if (isDetailModalOpen) setIsDetailModalOpen(false);
    },
    [isDetailModalOpen]
  );

  const handleEdit = (user) => {
    toggleAddEditModal(user);
  };

  const toggleMassModal = useCallback(
    (user = null) => {
      setIsMassModalOpen((prev) => !prev);
      if (isAddEditModalOpen) setIsAddEditModalOpen(false);
      if (isDetailModalOpen) setIsDetailModalOpen(false);
    },
    [isAddEditModalOpen, isDetailModalOpen]
  );

  const toggleDetailModal = useCallback(
    (user = null) => {
      setSelectedUser(user);
      setIsDetailModalOpen((prev) => !prev);
      if (isAddEditModalOpen) setIsAddEditModalOpen(false);
    },
    [isAddEditModalOpen]
  );

  const handleDetail = (userId) => {
    if (userId) {
      navigate(`/chauffeur/detail/${userId}`);
    }
  };

  const handleDelete = async (userId) => {
    try {
      await deleteDriver(userId);
      queryClient.invalidateQueries("users");
      toast.success("L'utilisateur a été supprimé avec succès 🎉");
    } catch (error) {
      console.error("Error deleting driver:", error);
      toast.error(
        `😔 Erreur lors de la suppression d'utilisateur : ${
          error?.message || error
        }`
      );
    } finally {
      setDeleteConfirmModal(false);
    }
  };

  const openDeleteConfirmModal = (userId) => {
    const userToDelete = users.find((user) => user.id === userId);
    if (userToDelete) {
      setDeleteTargetId(userId);
      setDeleteTargetFullName(userToDelete.name);
      setDeleteConfirmModal(true);
    }
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const handleSelectAll = () => {
    setIsAllSelected(!isAllSelected);
    if (!isAllSelected) {
      setSelectedRows(users.map((user) => user.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleCheckboxAndSelectAll = () => {
    handleCheckboxChange();
    handleSelectAll();
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "Actif":
      case "Actif #2FB550":
      case "Actif #2FB550":
        return "#2FB550";
      case "Inactif":
        return " #FF2D55";
      default:
        return " #FF9500";
    }
  };

  // const getCountryCodeFromPhone = (phone) => {
  //   const phoneNumber = parsePhoneNumberFromString(phone);
  //   return phoneNumber ? phoneNumber.country : "SN";
  // };

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div style={{ textAlign: "start", fontWeight: "normal" }}>
            {t("vehicle.name")}
          </div>
        ),
        accessor: "actualUserId",
        Cell: ({ row }) => {
          const avatarImage = row?.original?.fileName;
          const imageUrl = avatarImage
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
            : avatar1;
          const handleRedirectToDetails = () => {
            handleDetail(row?.original?.id);
          };

          return (
            <div
              onClick={handleRedirectToDetails}
              className="text-center"
              style={{ display: "flex", alignItems: "center" }}
            >
              {isLoading ? (
                "Chargement..."
              ) : row?.original?.fileName ? (
                <>
                  <Avatar
                    src={imageUrl}
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      marginRight: "8px",
                      cursor: "pointer",
                    }}
                  />
                  {row?.original?.name}
                </>
              ) : (
                t("vehicle.no_driver")
              )}
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>{t("drivers.phone")}</div>
        ),
        accessor: "phone",
        filterable: false,
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>{t("drivers.email")}</div>
        ),
        accessor: "email",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.email || t("drivers.noEmail")}
          </div>
        ),
        filterable: false,
      },
      {
        Header: () => (
          <div
            style={{ textAlign: "", fontWeight: "normal", marginLeft: "19px" }}
          >
            {t("vehicle.vehicle")}
          </div>
        ),
        accessor: "vehicle",
        Cell: ({ row }) => {
          const vehicle = row.original.vehicle?.fileName;
          const avatarImage = vehicle;
          const imageUrl = avatarImage
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
            : avatar1;
          return (
            <div
              className="text-center"
              style={{ display: "flex", alignItems: "center" }}
            >
              {isLoading ? (
                "Chargement..."
              ) : vehicle ? (
                <>
                  <Avatar
                    src={imageUrl}
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  />
                  <span style={{ textDecoration: "underline" }}>
                    {row.original.vehicle?.model}
                  </span>
                </>
              ) : (
                t("vehicle.no_vehicle")
              )}
            </div>
          );
        },
        filterable: false,
      },
      {
        Header: () => (
          <div style={{ textAlign: "center" }}>{t("drivers.adress")}</div>
        ),
        accessor: "address",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.address || t("drivers.noAdress")}
          </div>
        ),
        filterable: false,
      },
      {
        Header: () => (
          <div style={{ textAlign: "start", fontWeight: "normal" }}>
            {t("vehicle.status")}
          </div>
        ),
        accessor: "status",
        Cell: ({ row }) => {
          const statut = row?.original?.status || "Aucun status";
          const color = getStatusColor(statut);
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: color,
                  marginRight: "8px",
                }}
              ></span>
              <span>{statut}</span>
            </div>
          );
        },
        filterable: false,
      },

      {
        Header: () => (
          <div style={{ textAlign: "end", fontWeight: "normal" }}>
            {t("vehicle.actions")}
          </div>
        ),
        accessor: "action",
        headerStyle: { textAlign: "text-center" },
        Cell: ({ row }) => (
          <div className="actions-cell">
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                backgroundColor: "#f5f5f5",
                borderRadius: "50%",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
              }}
              onClick={() => toggleModal(row.original)} // Ouvre le modal avec les détails de la ligne sélectionnée
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#151515" />
                <circle cx="12" cy="12" r="2" fill="#151515" />
                <circle cx="18" cy="12" r="2" fill="#151515" />
              </svg>
            </div>
          </div>
        ),
        filterable: false,
      },
    ],
    [handleEdit, openDeleteConfirmModal, handleDetail]
  );
  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    bigButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 10px",
      backgroundColor: "#F6F6F6",
      color: "white",
      border: "none",
      borderRadius: "40px",
      cursor: "pointer",
      fontSize: "16px",
      position: "relative",
    },
    tabContainer: {
      display: "flex",
      gap: "5px",
      flexDirection: "row",
    },
    tabButton: {
      padding: "5px 16px",
      border: "none",
      borderRadius: "20px",
      cursor: "pointer",
      fontSize: "14px",
      transition: "background-color 0.3s",
      font: "Inter",
      fontWeight: "bold",
      backgroundColor: "#F6F6F6",
    },
  };
  // Filtrer les véhicules dont le statut est "En service"
  const driversInActif = users.filter((user) => user.status === "Actif");
  const numberOfDriversInActif = driversInActif.length;
  const driversInInActif = users.filter((user) => user.status === "Inactif");
  const numberOfDriversInInActif = driversInInActif.length;
  const driversArchive = users.filter((user) => user.status === "Archives");
  const numberOfDriversArchive = driversArchive.length;
  const nombre = users.filter((user) => user.role?.name === "DRIVER");
  const numberInDriver = nombre.length;
  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      <div style={styles.container}>
        <button style={styles.bigButton}>
          <div style={styles.tabContainer}>
            {tabs.map((tab) => (
              <button
                key={tab}
                style={{
                  ...styles.tabButton,
                  backgroundColor: activeTab === tab ? "#151515" : "#F6F6F6",
                  color: activeTab === tab ? "#FFFFFF" : "#595959",
                }}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
                {tab === "Tout" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "Tout" ? "#3D3D3D" : "#D9D9D9",
                      color: activeTab === "Tout" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberInDriver}
                  </div>
                )}
                {tab === "Actif" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === " Actif" ? "#3D3D3D" : "#D9D9D9",
                      color: activeTab === "Actif" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfDriversInActif}
                  </div>
                )}
                {tab === "Inactif" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "Inactif" ? "#3D3D3D" : "#D9D9D9",
                      color: activeTab === "Inactif" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfDriversInInActif}
                  </div>
                )}
                {tab === "Archivés" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "Archivés" ? "#3D3D3D" : "#D9D9D9", // Cercle blanc si actif, gris sinon
                      color: activeTab === "Archivés" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfDriversArchive}
                  </div>
                )}
              </button>
            ))}
          </div>
        </button>
      </div>
    </div>
  );

  const tabs = ["Tout", "Actif", "Inactif", "Archivés"];
  const [activeTab, setActiveTab] = useState("Tout");
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  <div className="d-flex gap-3">{renderTabs()}</div>;
  const navigate = useNavigate();
  const HeaderTable = () => (
    <div className="gap-3">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex gap-3">
          <strong style={{ fontSize: "24px" }}>
            {t("drivers.driver_list")}
          </strong>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* Bouton Export */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              height: "30px",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
            }}
            onClick={toggleModalExport}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Points du bouton d'export */}
              <circle cx="6" cy="12" r="2" fill="#151515" />
              <circle cx="12" cy="12" r="2" fill="#151515" />
              <circle cx="18" cy="12" r="2" fill="#151515" />
            </svg>
          </div>
          <button
            className="buttonAdd"
            onMouseOver={(e) => (e.target.style.backgroundColor = " #151515")}
            onMouseOut={(e) => (e.target.style.backgroundColor = " #151515")}
            onClick={() => toggleAddEditModal(null)}
          >
            <img
              src={IconDriver}
              alt="Ajouter plusieurs véhicules"
              style={{ width: "16px", height: "16px" }}
            />
            {t("drivers.chauffeur")}
          </button>
        </div>
      </div>
      <div style={{ marginTop: "20px" }}></div>
      {renderTabs()}
    </div>
  );
  const filteredUsers = useMemo(() => {
    if (!users) return error?.message || [];
    switch (activeTab) {
      case "Actif":
        return users.filter((v) => v.status === "Actif");
      case "Inactif":
        return users.filter((v) => v.status === "Inactif");
      case "Archivés":
        return users.filter((v) => v.status === "Archivés");
      default:
        return users;
    }
  }, [users, activeTab]);
  const filteredDrivers = filteredUsers.filter(
    (users) => users.role?.name === "DRIVER"
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("drivers.drivers")} history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={filteredDrivers || []}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={5}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    HeaderTable={HeaderTable}
                    SearchPlaceholder={t("drivers.searchPlaceholder")}
                  />
                  {isLoading && !isError && (
                    <div className="text-center">
                      {t("drivers.loading")} <Spin />
                    </div>
                  )}
                  {isError && (
                    <div className="text-center">
                      {t("drivers.error")}: {error?.message || error}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AddEditDriverForm
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedUser={selectedUser}
          />
          <AddDriverMass
            modal={isMassModalOpen}
            setModal={setIsMassModalOpen}
            toggle={toggleMassModal}
          />

          <Modal
            title={t("drivers.deleteConfirmationTitle")}
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
            footer={[
              <Button
                key="cancel"
                onClick={closeDeleteConfirmModal}
                className="bordered-btn-delete"
              >
                {t("drivers.no")}
              </Button>,
              <Button
                key="delete"
                type="danger"
                onClick={() => handleDelete(deleteTargetId)}
                className="bordered-btn"
              >
                {t("drivers.yes")}
              </Button>,
            ]}
            width={400}
            style={{ top: 200 }}
          >
            <p>
              {t("drivers.deleteConfirmationMessage")}
              {deleteTargetFullName} ?
            </p>
          </Modal>
          <Modal
            className={`modal-right ${modal ? "open" : ""}`}
            visible={isModalOpenExport}
            onCancel={toggleModalExport}
            footer={null}
            width={261}
            height={120}
            radiuis={9.6}
            border={0.96}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a
                onClick={() => {
                  toggleModalExport();
                  toggleAddEditModal(null);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  size: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <img src={vectorIcon} alt="Ajouter plusieurs véhicules" />
                <span>Ajouter plusieurs chauffeurs</span>
              </a>
              <a
                onClick={() => {
                  // Logic d'exportation CSV à ajouter ici
                  console.log("Exportation CSV...");
                  toggleModalExport();
                }}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vector1Icon}
                  alt="Export en csv"
                  style={{ marginRight: "8px" }}
                />
                <span>Exporter en CSV</span>
              </a>
            </div>
          </Modal>
          <Modal
            open={isModalOpen}
            onCancel={() => toggleModal()}
            footer={null}
            width={190}
            height={10}
            radiuis={9.6}
            border={0.96}
            style={{ top: "350px", right: "10px", position: "absolute" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a
                onClick={() => handleDetail(selectedUser?.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <EyeOutlined style={{ color: " #898989", width: "20px" }} />
                <span style={{ size: "14px", color: " #252525" }}>
                  Voir détails
                </span>
              </a>
              <a
                onClick={() => handleEdit(selectedUser)}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  marginBottom: "16px",
                }}
              >
                <EditOutlined style={{ color: " #898989" }} />
                <span style={{ marginLeft: "10px" }}>Editer chauffeur</span>
              </a>
              <a
                onClick={() => openDeleteConfirmModal(selectedUser.id)}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <DeleteOutlined style={{ color: " #898989" }} />
                <span style={{ marginLeft: "10px" }}>Archiver</span>
              </a>
              <a
                onClick={() => {
                  console.log("Exportation CSV...");
                  toggleModal();
                }}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vectorStatut}
                  alt="Export en csv"
                  style={{ width: "15px" }}
                />
                <span style={{ marginLeft: "10px" }}>Changer le statut</span>
              </a>
            </div>
          </Modal>
          <Modal
            className={`modal-right ${modal ? "open" : ""}`}
            visible={isModalOpenExport}
            onCancel={toggleModalExport}
            footer={null}
            width={300}
            height={120}
            radiuis={9.6}
            border={0.96}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a
                onClick={() => {
                  toggleMassModal();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  size: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <img src={vectorIcon} alt="Ajouter plusieurs véhicules" />
                <span>Ajouter plusieurs chauffeurs</span>
              </a>
              <a
                onClick={() => {
                  // Logic d'exportation CSV à ajouter ici
                  console.log("Exportation CSV...");
                  toggleModalExport();
                }}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vector1Icon}
                  alt="Export en csv"
                  style={{ marginRight: "8px" }}
                />
                <span>Exporter en CSV</span>
              </a>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Drivers;
